<template>

  <div class="shut-down-page">
    <div class="form-wrapper border border-light">

      <img class="bs-logo" src="@/assets/images/icons/bs-logo.svg">


      <div class="body">
        Hello Beautiful! Thanks for stopping by, and if you were a Bx user, thank you for all your support.
        While we remain committed to the idea of Beauty Scripts as a game changer for the industry,
        we've hit the end of our road in bringing it forward. 
      </div>

      <div class="signoff">Wishing you all the best!</div>
      <div class="signoff italic">Greta (founder) & the Bx Team</div>


    </div>

  </div>





</template>


<script>



export default {
  name: 'ShutDownPage',
  data () {
    return {

    }
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>

@import "@/assets/variables/_colors.scss";

.shut-down-page {
  background-color:               #EBE1DA;
  padding:                        6em 0;
  text-align:                     center;
  height:                         100%;
  position:                       fixed;
  top:                            0;
  left:                           0;
  right:                          0;
  bottom:                         0;
  overflow:                       scroll;
}

.form-wrapper {
  background:                     #fff;
  width:                          50%;
  margin:                         0 auto;
  padding:                        3em 1.5em 3em 1.5em;

  &:last-of-type {
    margin-top:                   5em;
  }

  > img {
    width: 5em;
    display: block;
    margin: 0 auto;
  }

  .body {
    margin-top: 3em;
    padding: 0 2em;
  }

  .signoff {
    margin-top: 1em;
  }

  .italic {
    font-style: italic;
  }
}

.form-signin {
  max-width:                      600px;
  margin:                         0 auto;

  > h2 {
    margin-bottom:                0.75em;
    display:                      inline-block;
  }

  .margin {
    margin-bottom:                1.5em;
  }

  > input {
    border: none;
    border-bottom:                1px solid black;
    margin-bottom:                0.5em;
    display:                      block;
    border-radius:                0;
    color:                        black;
    text-align:                   center;
  }

  .button {
    width:                        50%;
    font-family:                  'ProximaNovaLight';
    padding:                      0.5em;
    margin-top:                   0.75em;
    margin-bottom:                0.5em;
  }

}

.forgot-block {
  font-size:                      0.8em;
  margin:                         0.2em;
}

.signup-block {
  font-size:                      0.9em;
  max-width:                      330px;
  margin:                         2em auto 0 auto;

  > a {
    display:                      block;
    width:                        75%;
    margin:                       0.5em auto 0 auto;
    padding:                      0.5em;
    border:                       2px solid black;
    color:                        black;
    text-decoration:              none;

    &:hover {
      color:                      white;
      background-color:           black;
    }
  }
}

.form-signin .form-control {
  position:                       relative;
  height:                         auto;
  -webkit-box-sizing:             border-box;
          box-sizing:             border-box;
  padding:                        10px;
  font-size:                      16px;
}
.form-signin .form-control:focus {
  z-index:                        2;
}

.form-signin input[type="password"] {
  margin-bottom:                  10px;
}

.form-wrapper {
  animation:                      fadein 1.5s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}


/* Landscape phones and down */
@media (max-width: 480px) {
  .shut-down-page {
    padding:                        20% 10%;
  }
  .form-wrapper {
    width:                          100%;
  }
}

/* Landscape phone to portrait tablet */
@media (max-width: 767px) {
  .form-wrapper {
    width:                          100%;
  }

  .shut-down-page {
    padding-top:                    6em;
  }

  .form-signin {
    .button {
      width:                        75%;
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/components/ShutDownPage.vue